// IntegrationFieldSupport.jsx
import React from "react";

const items = [
{
  title: "Installation",
  desc: "Professional installation and integration services",
  icon: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9357 7.07169C16.6914 7.32092 16.5546 7.65602 16.5546 8.00502C16.5546 8.35402 16.6914 8.68911 16.9357 8.93835L19.0691 11.0717C19.3183 11.316 19.6534 11.4528 20.0024 11.4528C20.3514 11.4528 20.6865 11.316 20.9357 11.0717L25.9624 6.04502C26.6329 7.5266 26.8359 9.17733 26.5444 10.7772C26.2529 12.3771 25.4807 13.8501 24.3308 15.0001C23.1809 16.15 21.7078 16.9221 20.1079 17.2136C18.5081 17.5051 16.8573 17.3021 15.3757 16.6317L6.16241 25.845C5.63198 26.3755 4.91256 26.6734 4.16241 26.6734C3.41227 26.6734 2.69284 26.3755 2.16241 25.845C1.63198 25.3146 1.33398 24.5952 1.33398 23.845C1.33398 23.0949 1.63198 22.3755 2.16241 21.845L11.3757 12.6317C10.7053 11.1501 10.5023 9.49937 10.7938 7.89949C11.0853 6.29961 11.8575 4.82656 13.0074 3.67665C14.1573 2.52674 15.6303 1.75458 17.2302 1.46308C18.8301 1.17157 20.4808 1.37457 21.9624 2.04502L16.9491 7.05835L16.9357 7.07169Z"
        stroke="white"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

 {
  title: "HATS / SATS",
  desc: "Harbour and sea acceptance testing support",
  icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      color='white'
    >
      <path
        d="M4 7.5L7 10l4-5m-3.5 9.5a7 7 0 1 1 0-14a7 7 0 0 1 0 14Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
      />
    </svg>
  ),
},

{
  title: "On-site Support",
  desc: "Field engineering and commissioning teams",
  icon: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3327 28V25.3333C21.3327 23.9188 20.7708 22.5623 19.7706 21.5621C18.7704 20.5619 17.4138 20 15.9993 20H7.99935C6.58486 20 5.22831 20.5619 4.22811 21.5621C3.22792 22.5623 2.66602 23.9188 2.66602 25.3333V28"
        stroke="white"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9993 14.6667C14.9449 14.6667 17.3327 12.2789 17.3327 9.33333C17.3327 6.38781 14.9449 4 11.9993 4C9.05383 4 6.66602 6.38781 6.66602 9.33333C6.66602 12.2789 9.05383 14.6667 11.9993 14.6667Z"
        stroke="white"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.334 28V25.3333C29.3331 24.1516 28.9398 23.0037 28.2158 22.0698C27.4918 21.1358 26.4782 20.4688 25.334 20.1733"
        stroke="white"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.334 4.17334C22.4812 4.46707 23.498 5.13427 24.2242 6.06975C24.9503 7.00523 25.3444 8.15578 25.3444 9.34001C25.3444 10.5242 24.9503 11.6748 24.2242 12.6103C23.498 13.5457 22.4812 14.2129 21.334 14.5067"
        stroke="white"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

 {
  title: "Performance & Growth",
  desc: "Monitoring, optimization, and continuous improvement",
  icon: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.3327 9.3335L17.9993 20.6668L11.3327 14.0002L2.66602 22.6668"
        stroke="white"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.334 9.3335H29.334V17.3335"
        stroke="white"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

];

export default function IntegrationFieldSupport() {
  return (
    <section className="ifs">
      <style>{`
        :root{
          --accent:#ff8a00;
          --bg:#ffffff;
          --card:#ffffff;
          --text:#0f172a;
          --muted:#6b7280;
          --border:#eef2f7;
          --shadow:0 10px 24px rgba(0,0,0,.08);
          --radius:14px;
        }

        *{ box-sizing:border-box; }

        .ifs{
          background: var(--bg);
          padding: 3.5rem 1.5rem;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto;
        }

        .ifs__wrap{
          max-width: 1100px;
          margin: 0 auto;
          text-align: center;
        }

        .ifs__title{
          margin: 0;
          font-size: clamp(1.6rem, 2.5vw, 2rem);
          font-weight: 700;
          font-size: 36px;
          color: var(--text);
        }

        .ifs__sub{
          margin-top: .5rem;
          font-size: 18px;
          color: hsla(215, 16%, 47%, 1);
          font-weight: 400;
        }

        .ifs__grid{
          margin-top: 2.5rem;
          display: grid;
          grid-template-columns: repeat(4, minmax(0,1fr));
          gap: 1.25rem;
        }

        .ifs__card{
          background: var(--card);
          border: 1px solid var(--border);
          border-radius: var(--radius);
          padding: 1.5rem 1.25rem;
          box-shadow: var(--shadow);
          transition: transform .15s ease, box-shadow .15s ease;
        }

        .ifs__card:hover{
          transform: translateY(-3px);
          box-shadow: 0 16px 30px rgba(0,0,0,.12);
        }

        .ifs__icon{
          width: 46px;
          height: 46px;
          margin: 0 auto 1rem;
          border-radius: 12px;
          background: var(--accent);
          display: grid;
          place-items: center;
        }

        .ifs__icon svg{
          width: 22px;
          height: 22px;
          fill: #ffffff;
        }

        .ifs__label{
          margin: 0;
          font-size: .95rem;
          font-weight: 600;
          color: var(--text);
        }

        .ifs__desc{
          margin-top: .4rem;
          font-size: .8rem;
          color: var(--muted);
          line-height: 1.45;
        }

        /* Responsive */
        @media (max-width: 1024px){
          .ifs__grid{
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 520px){
          .ifs{
            padding: 2.5rem 1rem;
          }
          .ifs__grid{
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="ifs__wrap">
        <h2 className="ifs__title">Integration & Field Support</h2>
        <p className="ifs__sub">
          End-to-end support from installation to commissioning
        </p>

        <div className="ifs__grid">
          {items.map((item) => (
            <article className="ifs__card" key={item.title}>
              <div className="ifs__icon">{item.icon}</div>
              <h3 className="ifs__label">{item.title}</h3>
              <p className="ifs__desc">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

